// extracted by mini-css-extract-plugin
export default {"article":"AgHistoryPage_article__AFNcH","postDate":"AgHistoryPage_postDate__Cig2R","breadcrumbs":"AgHistoryPage_breadcrumbs__GDYtM","content":"AgHistoryPage_content__B0A05"};